/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const SliderFragment = {
  Slider: gql`
    fragment SliderQuery on slider_Entry {
      asideContent
      lineBreak_content
      lineBreak_styles
      sideContentStateSeal {
        url
        ... on images_Asset {
          altText
        }
      }
      sliderAlignment
      sliderSlides {
        ... on sliderSlidesBlock_Entry {
          slideContent {
            html
          }
          slideImage {
            url
            ... on images_Asset {
              altText
              width
              height
            }
          }
          slideImageLink
          slideLinkNewTab
          slideLinkNofollow
        }
      }
      sliderTitle
      styles
      typeHandle
    }
  `,
};
